module.exports = __webpack_public_path__ + "static/media/tray6.c7e39261.png";